module.exports = __webpack_public_path__ + "static/media/piggy-coin.270f7ece.webp";